var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "text text-l-large-bold grey--text text--darken-2"
  }, [_vm._v("Selected plan")]), _c('PlanCardOnboardingComponent', {
    attrs: {
      "plan-info": _vm.planSelected,
      "show-per-year": true,
      "is-preview-on-checkout": true
    }
  }), !_vm.showDiscountCodeField && !_vm.hideAddDiscountActionIfPlanIsLifetime ? _c('div', {
    staticClass: "mt-6 mb-8"
  }, [_c('v-row', {
    staticClass: "text-center",
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', [_c('p', {
    staticClass: "primary--text text text-l-large-regular-link clickable mb-0 d-flex align-start justify-center",
    on: {
      "click": function ($event) {
        _vm.showDiscountCodeField = true;
      }
    }
  }, [_c('ph-plus', {
    staticClass: "primary--text mr-2 icon-plus",
    attrs: {
      "weight": "bold",
      "size": "16"
    }
  }), _vm._v("Add discount code ")], 1)])], 1)], 1) : _vm._e(), _vm.showDiscountCodeField && !_vm.hideAddDiscountActionIfPlanIsLifetime ? _c('div', {
    staticClass: "mt-4 mb-6"
  }, [_c('v-row', {
    staticClass: "card-base-background shadow-card border-radius-small px-4 pt-4 mt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "field-custom-label",
    attrs: {
      "placeholder": "Write your discount code",
      "height": "46",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('label', {
          staticClass: "text text-m-small-bold"
        }, [_vm._v("Discount code")])];
      },
      proxy: true
    }], null, false, 858351128),
    model: {
      value: _vm.discountPromoCode,
      callback: function ($$v) {
        _vm.discountPromoCode = $$v;
      },
      expression: "discountPromoCode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "heading heading-s-small primary--text shadow-light-button",
    attrs: {
      "ripple": "",
      "depressed": "",
      "height": "44px",
      "block": "",
      "color": "white"
    },
    on: {
      "click": _vm.submitDiscountCode
    }
  }, [_vm._v(" Submit discount code ")])], 1)], 1)], 1) : _vm._e(), _c('div', [_c('h3', {
    staticClass: "text text-l-large-bold grey--text text--darken-2 mb-2"
  }, [_vm._v("Payment details")]), !_vm.isLifetimePlan ? _c('p', {
    staticClass: "text grey--text text--darken-2",
    class: {
      'text-l-small-regular': _vm.$vuetify.breakpoint.smAndUp,
      'text-l-large-regular': _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_vm._v(" You will be charged " + _vm._s(_vm.planSelected.yearCycle === '1' ? 'yearly' : 'every ' + _vm.planSelected.yearCycle + ' years') + ". Cancel your subscription or revise your plan any time from your profile ")]) : _vm._e(), _c('div', {
    staticClass: "card-base-background shadow-card border-radius-small pa-4 mb-6"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text text-l-large-regular grey--text text--darken-3"
  }, [_vm._v(_vm._s(_vm.planSelected.title) + " plan")]), _c('span', {
    staticClass: "text text-l-large-bold grey--text text--darken-1"
  }, [_vm._v("$" + _vm._s(_vm.isLifetimePlan && _vm.planSelected.saveMoney ? _vm.planSelected.saveMoney : _vm.planSelected.price))])]), _vm.isLifetimePlan && _vm.planSelected.hasDiscount || _vm.hasDiscount ? _c('div', {
    staticClass: "d-flex justify-space-between mt-2"
  }, [_c('span', {
    staticClass: "text text-l-large-regular grey--text text--darken-3"
  }, [_vm._v(_vm._s(_vm.isLifetimePlan ? '40% discount' : 'Discount'))]), _c('span', {
    staticClass: "text text-l-large-bold success--text"
  }, [_vm._v(_vm._s(_vm.isLifetimePlan ? '-$' + _vm.planSelected.discountByDefault : _vm.discountFormat))])]) : _vm._e(), _vm.currentPlanPriceHash ? _c('div', [_c('v-divider', {
    staticClass: "my-3"
  }), _c('v-row', {
    staticClass: "text text-l-small-regular plan-prorate-details border-bottom-line py-4 px-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center",
    attrs: {
      "cols": "8"
    }
  }, [_c('h4', {}, [_vm._v(_vm._s(_vm.currentPlanName) + " plan")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("You have already paid")])]), _c('v-col', {
    staticClass: "text-right align-self-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "pr-5"
  }, [_vm._v("$ " + _vm._s(_vm.remainingAmount))])])], 1), _c('v-row', {
    staticClass: "text text-l-small-regular plan-prorate-details darker border-bottom-line py-4 px-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center",
    attrs: {
      "cols": "8"
    }
  }, [_c('h4', {}, [_vm._v(_vm._s(_vm.planSelected.title) + " plan")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("The charge for upgrading is")])]), _c('v-col', {
    staticClass: "text-right align-self-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "pr-5"
  }, [_vm._v("$ " + _vm._s(_vm.unusedAmount))])])], 1), _c('v-row', {
    staticClass: "text text-l-small-regular plan-prorate-details darker py-4 px-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center",
    attrs: {
      "cols": "8"
    }
  }, [_c('h4', {}, [_vm._v("Total amount")])]), _c('v-col', {
    staticClass: "text-right align-self-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "text text-l-large-bold pr-5 primary--text"
  }, [_vm._v("$ " + _vm._s(_vm.totalAmount))])])], 1)], 1) : _vm._e(), _c('v-divider', {
    staticClass: "my-3"
  }), _c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "heading heading-s-small grey--text text--darken-4"
  }, [_vm._v("Total payment")]), _vm.hasDiscount ? _c('span', {
    staticClass: "heading heading-s-large primary--text"
  }, [_vm._v("$" + _vm._s(_vm.totalWithDiscount))]) : _c('span', {
    staticClass: "heading heading-s-large primary--text"
  }, [_vm._v("$" + _vm._s(_vm.currentPlanPriceHash ? _vm.totalAmount : new Intl.NumberFormat('en-IN', {
    maximumSignificantDigits: 3
  }).format(_vm.isLifetimePlan ? _vm.planSelected.priceWithDiscount : _vm.planSelected.price)))])])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }